module.exports = __webpack_public_path__ + "img/red-heart.0da24f80.svg";